import React from "react";

const ClientsSection = () => {
  return (
    <section className="prt-row bg-img2 prt-bgimage-yes prt-bg bg-base-dark client-section z-index-0 clearfix">
      <div className="container-fluid">
        <div
          className="row slick_slider"
          data-slick='{
            "slidesToShow": 4, 
            "slidesToScroll": 1, 
            "arrows": false, 
            "dots": false, 
            "autoplay": true, 
            "infinite": true,
            "responsive": [
              {"breakpoint":1400,"settings":{"slidesToShow":4}},
              {"breakpoint":1024,"settings":{"slidesToShow":3}},
              {"breakpoint":700,"settings":{"slidesToShow":2}},
              {"breakpoint":575,"settings":{"slidesToShow":1}}
            ]
          }'
        >
      
          {/* Repeat similar blocks for additional client logos */}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
